import { useQuery } from '@tanstack/react-query';
import { getAppConfiguration } from '@utils/browserEnv';
import { message } from 'antd';
import axios from 'axios';
import { TWO_HOURS_IN_MILLISECONDS } from 'mdc-constants';
import { useCallback, useMemo, useState } from 'react';
import { useAccessToken } from 'services';

const { cmsFullApiUrl } = getAppConfiguration();

type Props = {
  page: number;
  perPage: number;
};

export default function useUserAllFavoriteBoats({ page, perPage }: Props) {
  const { data: accessToken } = useAccessToken();

  const getUserHasFavoriteCollection = useCallback(
    () =>
      axios
        .get(`${cmsFullApiUrl}/user-favorite-boats?page=${page}&perPage=${perPage}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: accessToken,
          },
        })
        .then((res) => res.data),
    [accessToken, page, perPage],
  );

  const {
    data: favoriteBoats,
    isLoading,
    refetch: reFetchAll,
    isFetched,
  } = useQuery({
    queryFn: getUserHasFavoriteCollection,
    queryKey: ['userFavoriteBoatsPage', perPage, page],
    enabled: !!accessToken,
    gcTime: TWO_HOURS_IN_MILLISECONDS,
  });

  const total = useMemo(() => {
    if (favoriteBoats?.pagination?.total) {
      return favoriteBoats.pagination.total;
    }
  }, [favoriteBoats]);

  const userHasFavoriteCollection = useMemo(() => {
    return favoriteBoats?.data?.length > 0;
  }, [favoriteBoats]);

  return {
    favoriteBoats,
    isLoading,
    reFetchAll,
    total,
    isFetched,
    userHasFavoriteCollection,
  };
}
